import { initializeAuth } from '../store/auth/action-creators';
import { Tracker } from '../store/tracking/action-creators';
import { Auth } from './authUtils';
import { setIsExistingUserSession } from '../store/app/action-creators';
import { isPostVerification } from '../flow-settings/settingsSelectors';
export const getAuth = () => dispatch => {
  return dispatch(Auth.init()).then(response => {
    if (response) {
      dispatch(initializeAuth(true, response.email));
      dispatch(Tracker.authState('authed'));
      dispatch(setIsExistingUserSession(true));

      if (!isPostVerification()) {
        dispatch(Tracker.signupPageView('authenticated'));
      }
    }
  }).catch(() => {
    dispatch(initializeAuth(false));
    dispatch(Tracker.authState('not-authed'));

    if (!isPostVerification()) {
      dispatch(Tracker.signupPageView('unauthenticated'));
    }
  });
};